import React, { useMemo } from 'react';
import { introductionList } from './data';

export default function Introduction() {
  const introductionItems = useMemo(
    () =>
      introductionList.map((introductionItem) => (
        <li key={introductionItem.id} className="introduction-item">
          <figure className="introduction-item__header">
            {introductionItem.Icon}
            <figcaption className="introduction-item__title">
              {introductionItem.title}
            </figcaption>
          </figure>
          <ul className="introduction-item__content">
            {introductionItem.descriptions.map((description) => (
              <li className="introduction-item__description" key={description}>
                <img
                  className="introduction-item__description--icon"
                  src="/svg/aboutUs/checklist-icon.svg"
                  alt="bullet icon"
                />
                {description}
              </li>
            ))}
          </ul>
        </li>
      )),
    []
  );

  return (
    <section className="introduction">
      <div className="introduction__container">
        <article className="introduction__content">
          <header className="introduction__header">
            <h2 className="introduction__heading">INTRODUCTION</h2>
            <h3 className="introduction__title">What is bravoSUITE?</h3>
          </header>
          <p className="introduction__description">
            bravoSUITE is the ultimate human resources tool that will centralize
            all the talent management activities within your business.
          </p>
          <ul className="introduction__list">{introductionItems}</ul>
        </article>
        <footer className="introduction__footer">
          <figure className="introduction__bravosuite-logo">
            <img
              src="/svg/logos/logo-suite.svg"
              alt="BravoSUITE"
              title="BravoSUITE"
            />
            <figcaption>Smart Talent Management System</figcaption>
          </figure>
        </footer>
      </div>
    </section>
  );
}
